import React from 'react';
import { Globe, CreditCard, Wallet, MoveRight } from 'lucide-react';
import '../../../../../styles/components/auction-enrollment.scss';
import { SAR } from '../../../../common/icons';
import { EnrollmentList } from './AuctionEnrollment/EnrollmentList';
import i18n from '../../../../../i18n';

class CashFlowTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animateCharts: false,
      showTransaction: false,
      method: null,
    };
  }

  componentDidMount() {
    // Trigger animation on mount
    setTimeout(() => {
      this.setState({ animateCharts: true });
    }, 100);
  }

  showPaymentHistory = (method) => {
    this.setState({ showTransaction: true, method });
  };

  render() {
    const { search, data, totalCount = 0, totalAmount = 0 } = this.props;

    const renderIcon = (iconType) => {
      switch (iconType) {
        case 'globe':
          return <Globe size={20} />;
        case 'creditCard':
          return <CreditCard size={20} />;
        case 'wallet':
          return <Wallet size={20} />;
        default:
          return <Globe size={20} />;
      }
    };

    const formatNumber = (value) => {
      return new Intl.NumberFormat('en-US').format(value);
    };
    const { showTransaction, method } = this.state;
    return (
      <div className="table-section">
        {/* Table Header */}
        <div className="table-header">
          <div className="column payment-method">{i18n.t('payment_method')}</div>
          <div className="column count">{i18n.t('count')}</div>
          <div className="column amount">{i18n.t('amount')}</div>
          {/* <div className="column percentage">% OF TOTAL</div> */}
          <div className="column action">{i18n.t('action')}</div>
        </div>

        {/* Table Rows */}
        <div className="table-body">
          {data.map((row, index) => (
            <div key={row.id} className="table-row">
              <div className="column payment-method">
                <div className="method-content">
                  <div className="method-icon" style={{ backgroundColor: `${row.color}15` }}>
                    <span style={{ color: row.color }}>{renderIcon(row.icon)}</span>
                  </div>
                  <span className="method-name">{row.method}</span>
                </div>
              </div>

              <div className="column count">
                <span className="count-value">{formatNumber(row.count)}</span>
              </div>

              <div className="column amount">
                <div className="amount-content">
                  <span className="amount-value" style={{ color: row.color }}>
                    {row.amount}
                  </span>
                  <div className="amount-icon">
                    <SAR size={10} color={row.color} />
                  </div>
                </div>
              </div>
              <div className="column action">
                <button className="action-row" onClick={() => this.showPaymentHistory(row.type)}>
                  <span className="action-row__text">{i18n.t('details')}</span>
                  <MoveRight className="action-row__icon" size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Total Row */}
        <div className="table-footer">
          <div className="total-row">
            <div className="column payment-method">
              <span className="total-label">{i18n.t('total')}</span>
            </div>
            <div className="column count">
              <span className="total-value">{formatNumber(totalCount)}</span>
            </div>
            <div className="column amount">
              <span className="total-value">
                {totalAmount} <SAR size={10} color={'#1b8f9b'} />
              </span>
            </div>

            <div className="column action">
              <button className="action-row primary" onClick={() => this.showPaymentHistory(null)}>
                <span className="action-row__text">{i18n.t('all')}</span>
                <MoveRight className="action-row__icon" size={18} />
              </button>
            </div>
          </div>
        </div>

        <EnrollmentList
          show={showTransaction}
          search={search}
          method={method}
          onClose={() => this.setState({ showTransaction: false, method: null })}
        />
      </div>
    );
  }
}

export default CashFlowTable;
